var _g, _path, _g2, _path2, _rect, _rect2, _path3, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1057,
    height: 674,
    viewBox: "0 0 1057 674",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2704_23661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M595.06 25.6122C599.255 23.1903 606.056 23.1903 610.251 25.6122L881.806 182.381C886.001 184.802 886.001 188.729 881.806 191.151L717.587 285.954C713.392 288.376 706.59 288.376 702.395 285.954L430.841 129.186C426.646 126.764 426.646 122.837 430.841 120.416L595.06 25.6122Z",
    fill: "#FFEEE9",
    stroke: "#FFEEE9",
    strokeWidth: 5.30404
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.220987,
    width: 40.8012,
    height: 27.7081,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 605.042 34.1122)",
    fill: "#171C60",
    stroke: "#FFEEE9",
    strokeWidth: 0.442003
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.220987,
    width: 247.276,
    height: 15.3698,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 652.926 62.3668)",
    fill: "#A3BBDC",
    stroke: "#FFEEE9",
    strokeWidth: 0.442003
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.656 28.2653L877.21 185.034C878.867 185.99 878.867 187.541 877.21 188.498L712.991 283.301C711.334 284.258 708.648 284.258 706.991 283.301L435.437 126.533C433.78 125.576 433.78 124.025 435.437 123.069L599.655 28.2653C601.312 27.3088 603.999 27.3088 605.656 28.2653ZM613.505 23.7338C607.513 20.2745 597.798 20.2745 591.806 23.7338L427.587 118.537C421.595 121.996 421.595 127.605 427.587 131.064L699.142 287.833C705.134 291.292 714.849 291.292 720.841 287.833L885.06 193.029C891.052 189.57 891.052 183.961 885.06 180.502L613.505 23.7338Z",
    fill: "white",
    stroke: "#FFEEE9",
    strokeWidth: 2.21002
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    y: 0.220987,
    width: 23.8852,
    height: 9.64086,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 672.963 101.604)",
    fill: "#FFA993",
    stroke: "#FFEEE9",
    strokeWidth: 0.442003
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    y: 0.220987,
    width: 160.118,
    height: 9.64086,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 704.566 119.848)",
    fill: "#FFA993",
    stroke: "#FFEEE9",
    strokeWidth: 0.442003
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    y: 0.220987,
    width: 23.8852,
    height: 9.64086,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 654.625 112.19)",
    fill: "#FFA993",
    stroke: "#FFEEE9",
    strokeWidth: 0.442003
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    y: 0.220987,
    width: 160.118,
    height: 9.64086,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 686.228 130.435)",
    fill: "#FFA993",
    stroke: "#FFEEE9",
    strokeWidth: 0.442003
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    y: 0.220987,
    width: 23.8852,
    height: 9.64086,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 636.288 122.776)",
    fill: "#FFA993",
    stroke: "#FFEEE9",
    strokeWidth: 0.442003
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    y: 0.220987,
    width: 160.118,
    height: 9.64086,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 667.891 141.021)",
    fill: "#FFA993",
    stroke: "#FFEEE9",
    strokeWidth: 0.442003
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    y: 0.220987,
    width: 23.8852,
    height: 9.64086,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 617.95 133.363)",
    fill: "#FFA993",
    stroke: "#FFEEE9",
    strokeWidth: 0.442003
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    y: 0.220987,
    width: 160.118,
    height: 9.64086,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 649.553 151.607)",
    fill: "#FFA993",
    stroke: "#FFEEE9",
    strokeWidth: 0.442003
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    y: 0.220987,
    width: 23.8852,
    height: 9.64086,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 599.612 143.949)",
    fill: "#FFA993",
    stroke: "#FFEEE9",
    strokeWidth: 0.442003
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    y: 0.220987,
    width: 160.118,
    height: 9.64086,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 631.216 162.193)",
    fill: "#FFA993",
    stroke: "#FFEEE9",
    strokeWidth: 0.442003
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    y: 0.220987,
    width: 23.8852,
    height: 9.64086,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 581.275 154.535)",
    fill: "#FFA993",
    stroke: "#FFEEE9",
    strokeWidth: 0.442003
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    y: 0.220987,
    width: 160.118,
    height: 9.64086,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 612.878 172.78)",
    fill: "#FFA993",
    stroke: "#FFEEE9",
    strokeWidth: 0.442003
  })), /*#__PURE__*/React.createElement("path", {
    d: "M525.958 127.861L525.95 127.861C525.482 127.82 525.021 127.781 524.568 127.742C524.501 127.481 524.432 127.215 524.363 126.944L524.362 126.939C523.886 125.095 523.359 123.049 522.902 120.827C529.907 121.804 537.65 122.563 546.011 122.799L547.161 122.831C554.785 123.08 563.098 122.977 571.934 122.087C588.292 120.438 606.904 116.009 625.355 105.248L626.222 104.743L625.603 104.133C617.626 96.2722 605.858 88.1628 599.714 84.3986L599.682 84.3789L599.648 84.3603C593.127 80.8133 579.08 74.02 565.464 69.4148L564.408 69.0574L563.532 69.558C544.892 80.2096 537.22 90.9543 534.364 100.398C533.155 104.396 532.784 108.208 532.888 111.79C528.993 111.376 525.28 110.857 521.745 110.282C521.759 96.0956 528.845 78.134 562.158 61.2911C579.767 66.091 599.471 75.6453 607.333 79.949L607.344 79.9554L607.355 79.9619C614.81 84.5002 631.36 95.8756 639.674 106.041C617.247 120.825 593.695 126.65 572.886 128.567C558.358 129.905 545.111 129.343 534.419 128.552C531.382 128.327 528.556 128.084 525.958 127.861Z",
    fill: "#1956A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.508 98.5316C554.028 94.1905 566.178 94.1664 573.646 98.4778C581.114 102.789 581.072 109.803 573.553 114.145L572.463 114.773L545.419 99.1605L546.508 98.5316Z",
    fill: "#1956A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.801 97.0123C585.94 99.2408 579.703 99.2532 575.87 97.04C572.036 94.8267 572.057 91.226 575.917 88.9975C579.778 86.769 586.015 86.7566 589.849 88.9699C593.682 91.1831 593.661 94.7838 589.801 97.0123Z",
    fill: "#1956A8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 328.094,
    height: 27.6706,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 450.753 110.347)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.405 121.983L448.564 121.314L458.092 123.548L456.857 124.261L449.365 122.453L452.476 126.791L451.241 127.504L447.405 121.983ZM455.657 126.747L456.816 126.078L466.344 128.312L465.109 129.025L457.616 127.217L460.728 131.554L459.493 132.267L455.657 126.747ZM463.909 131.511L465.068 130.841L474.596 133.076L473.361 133.789L465.868 131.98L468.98 136.318L467.745 137.031L463.909 131.511ZM472.16 136.274L473.319 135.605L482.847 137.84L481.612 138.552L474.12 136.744L477.231 141.082L475.996 141.795L472.16 136.274ZM480.412 141.038L481.571 140.369L491.099 142.603L489.864 143.316L482.371 141.508L485.483 145.845L484.248 146.558L480.412 141.038ZM488.664 145.802L489.823 145.132L499.351 147.367L498.116 148.08L490.623 146.272L493.735 150.609L492.5 151.322L488.664 145.802ZM496.915 150.565L498.074 149.896L507.602 152.131L506.367 152.844L498.875 151.035L501.986 155.373L500.751 156.086L496.915 150.565ZM505.167 155.329L506.326 154.66L515.854 156.894L514.619 157.607L507.126 155.799L510.238 160.136L509.003 160.849L505.167 155.329ZM513.419 160.093L514.578 159.423L524.106 161.658L522.871 162.371L515.378 160.563L518.49 164.9L517.255 165.613L513.419 160.093ZM521.67 164.856L522.829 164.187L532.357 166.422L531.122 167.135L523.63 165.326L526.741 169.664L525.506 170.377L521.67 164.856ZM529.922 169.62L531.081 168.951L540.609 171.185L539.374 171.898L531.881 170.09L534.993 174.427L533.758 175.14L529.922 169.62ZM538.174 174.384L539.333 173.715L548.861 175.949L547.626 176.662L540.133 174.854L543.245 179.191L542.01 179.904L538.174 174.384ZM546.425 179.147L547.584 178.478L557.112 180.713L555.877 181.426L548.385 179.617L551.496 183.955L550.261 184.668L546.425 179.147ZM554.677 183.911L555.836 183.242L565.364 185.476L564.129 186.189L556.636 184.381L559.748 188.719L558.513 189.432L554.677 183.911ZM562.929 188.675L564.088 188.006L573.616 190.24L572.381 190.953L564.888 189.145L568 193.482L566.765 194.195L562.929 188.675ZM571.18 193.438L572.339 192.769L581.867 195.004L580.632 195.717L573.14 193.908L576.251 198.246L575.016 198.959L571.18 193.438ZM579.432 198.202L580.591 197.533L590.119 199.767L588.884 200.48L581.391 198.672L584.503 203.01L583.268 203.723L579.432 198.202ZM587.684 202.966L588.843 202.297L598.371 204.531L597.136 205.244L589.643 203.436L592.755 207.773L591.52 208.486L587.684 202.966ZM595.935 207.729L597.094 207.06L606.622 209.295L605.387 210.008L597.895 208.199L601.006 212.537L599.771 213.25L595.935 207.729ZM604.187 212.493L605.346 211.824L614.874 214.059L613.639 214.771L606.146 212.963L609.258 217.301L608.023 218.014L604.187 212.493ZM612.439 217.257L613.598 216.588L623.126 218.822L621.891 219.535L614.398 217.727L617.51 222.064L616.275 222.777L612.439 217.257ZM620.69 222.021L621.849 221.351L631.377 223.586L630.142 224.299L622.65 222.491L625.761 226.828L624.526 227.541L620.69 222.021ZM628.942 226.784L630.101 226.115L639.629 228.35L638.394 229.063L630.901 227.254L634.013 231.592L632.778 232.305L628.942 226.784ZM637.194 231.548L638.353 230.879L647.881 233.113L646.646 233.826L639.153 232.018L642.265 236.355L641.03 237.068L637.194 231.548ZM645.445 236.312L646.604 235.642L656.132 237.877L654.897 238.59L647.405 236.782L650.516 241.119L649.281 241.832L645.445 236.312ZM653.697 241.075L654.856 240.406L664.384 242.641L663.149 243.354L655.656 241.545L658.768 245.883L657.533 246.596L653.697 241.075ZM661.949 245.839L663.108 245.17L672.636 247.404L671.401 248.117L663.908 246.309L667.02 250.646L665.785 251.359L661.949 245.839ZM670.2 250.603L671.359 249.934L680.887 252.168L679.652 252.881L672.16 251.073L675.271 255.41L674.036 256.123L670.2 250.603ZM678.452 255.366L679.611 254.697L689.139 256.932L687.904 257.645L680.411 255.836L683.523 260.174L682.288 260.887L678.452 255.366ZM686.704 260.13L687.863 259.461L697.391 261.695L696.156 262.408L688.663 260.6L691.775 264.938L690.54 265.651L686.704 260.13ZM694.955 264.894L696.114 264.225L705.642 266.459L704.407 267.172L696.915 265.364L700.026 269.701L698.791 270.414L694.955 264.894ZM703.207 269.657L704.366 268.988L713.894 271.223L712.659 271.936L705.166 270.127L708.278 274.465L707.043 275.178L703.207 269.657ZM711.459 274.421L712.618 273.752L722.146 275.986L720.911 276.699L713.418 274.891L716.53 279.229L715.295 279.942L711.459 274.421Z",
    fill: "#E8EFFB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M202.192 132.096L36.2343 245.839L386.369 188.501L285.121 130.051C261.778 116.575 223.459 117.52 202.192 132.096Z",
    fill: "#9FC1EF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2704_23661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6912 267.791C31.3855 258.955 31.3855 244.629 46.6912 235.793L269.864 106.955C285.17 98.1189 309.986 98.1189 325.291 106.955L667.373 304.438C682.678 313.274 682.678 327.6 667.373 336.436L444.199 465.274C428.894 474.11 404.078 474.11 388.773 465.274L46.6912 267.791Z",
    fill: "#1956A8"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.701 207.647C183.046 231.694 183.036 270.676 224.677 294.715C266.318 318.755 333.843 318.749 375.497 294.701C417.152 270.654 417.162 231.672 375.521 207.633C333.88 183.593 266.355 183.599 224.701 207.647ZM366.544 222.488C383.688 235.69 387.473 252.842 377.903 267.793C371.101 258.076 358.482 247.241 341.82 236.761L366.544 222.488ZM338.629 256.042C334.603 252.902 330.057 249.678 325.023 246.458L291.93 265.563C297.507 268.469 303.092 271.093 308.532 273.417L313.433 275.447C319.903 278.041 326.09 280.185 331.72 281.846L335.835 282.999C347.171 286.009 355.685 286.794 358.742 285.029C361.8 283.264 360.44 278.349 355.227 271.804L353.228 269.429C350.353 266.178 346.638 262.607 342.145 258.872L338.629 256.042ZM349.789 212.815L325.065 227.089C306.911 217.47 288.144 210.185 271.312 206.258C297.209 200.733 326.921 202.918 349.789 212.815ZM233.654 279.86C216.51 266.658 212.725 249.506 222.295 234.555C229.097 244.272 241.716 255.107 258.378 265.587L233.654 279.86ZM261.569 246.306C265.595 249.446 270.141 252.67 275.175 255.89L308.268 236.785C302.691 233.879 297.106 231.255 291.666 228.931L286.765 226.901C280.295 224.307 274.108 222.163 268.478 220.502L264.364 219.348C253.027 216.339 244.513 215.554 241.456 217.319C238.398 219.084 239.758 223.999 244.971 230.544L246.97 232.919C249.845 236.17 253.56 239.741 258.053 243.476L261.569 246.306ZM250.409 289.533L275.133 275.259C293.287 284.878 312.054 292.163 328.886 296.09C302.989 301.615 273.277 299.43 250.409 289.533Z",
    fill: "#F5F9FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 111.97,
    height: 18.3597,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 432.415 385.615)",
    fill: "#F5F9FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 111.97,
    height: 4.14574,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 455.496 398.939)",
    fill: "#F5F9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.695 388.274L533.992 370.206L542.199 374.943L532.357 380.625C529.249 379.387 524.957 379.567 522.19 381.164C519.424 382.761 519.112 385.239 521.256 387.034L510.901 393.011L502.695 388.274ZM523.307 388.218L512.953 394.196L520.647 398.637L551.944 380.569L544.25 376.128L534.409 381.809C536.553 383.604 536.241 386.081 533.474 387.679C530.708 389.276 526.416 389.456 523.307 388.218ZM531.727 383.358C532.481 384.28 532.199 385.415 530.876 386.179C529.554 386.942 527.587 387.105 525.99 386.67L531.727 383.358ZM529.675 382.173L523.938 385.485C523.183 384.563 523.466 383.428 524.788 382.664C526.111 381.901 528.078 381.737 529.675 382.173Z",
    fill: "#F5F9FF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2704_23661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.343 505.965C460.05 502.332 460.292 496.302 466.884 492.497L794.507 303.36C801.099 299.555 811.544 299.415 817.837 303.048L1006.99 412.243C1013.28 415.876 1013.04 421.906 1006.44 425.711L678.821 614.848C672.23 618.654 661.784 618.793 655.491 615.161L466.343 505.965Z",
    fill: "#E8EFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.38 497.402L803.003 308.265C804.797 307.229 807.488 307.257 809.017 308.14L998.165 417.335C999.694 418.218 999.742 419.771 997.949 420.807L670.325 609.944C668.532 610.979 665.841 610.951 664.312 610.069L475.164 500.873C473.634 499.99 473.586 498.437 475.38 497.402ZM465.225 491.539C457.79 495.831 457.403 502.72 464.684 506.923L653.832 616.118C661.113 620.322 673.046 620.098 680.48 615.806L1008.1 426.669C1015.54 422.377 1015.93 415.489 1008.64 411.285L819.496 302.09C812.215 297.887 800.283 298.11 792.848 302.402L465.225 491.539Z",
    fill: "white",
    stroke: "#E8EFFB",
    strokeWidth: 3.83174
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.6129,
    height: 18.4197,
    rx: 4,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 760.413 339.487)",
    fill: "#171C60"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2704_23661)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.6129,
    height: 18.4197,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 486.498 497.618)",
    fill: "#171C60"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.1595,
    height: 18.4197,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 516.337 480.393)",
    fill: "#FF5326"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.9158,
    height: 18.4197,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 500.82 489.35)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 219.813,
    height: 18.4197,
    rx: 4,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 544.981 463.856)",
    fill: "#A3BBDC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 219.813,
    height: 6.57846,
    rx: 3.28923,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 563.782 474.71)",
    fill: "#A3BBDC"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 128.187,
    height: 16.3296,
    rx: 4,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 700.73 481.594)",
    fill: "#A3BBDC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 128.187,
    height: 15.5131,
    rx: 4,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 718.408 492.616)",
    fill: "#A3BBDC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 127.371,
    height: 16.3296,
    rx: 4,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 736.792 502.413)",
    fill: "#A3BBDC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 127.371,
    height: 15.5131,
    rx: 4,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 755.177 513.027)",
    fill: "#A3BBDC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 80.621,
    height: 15.7883,
    rx: 4,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 874.74 444.073)",
    fill: "#A3BBDC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 76.749,
    height: 15.5131,
    rx: 4,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 646.99 450.57)",
    fill: "#A3BBDC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 128.187,
    height: 16.3296,
    rx: 4,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 674.567 467.307)",
    fill: "#A3BBDC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 70.285,
    height: 9.20984,
    rx: 4,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 894.508 455.078)",
    fill: "#A3BBDC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M692.789 556.361L692.788 556.367C692.699 556.703 692.612 557.034 692.527 557.359C691.963 557.408 691.39 557.459 690.808 557.51L690.798 557.511C686.824 557.86 682.418 558.247 677.631 558.584C679.764 553.554 681.432 547.994 681.975 541.994L682.05 541.169C682.619 535.697 682.432 529.733 680.553 523.397C677.074 511.666 667.618 498.33 644.529 485.137L643.443 484.517L642.127 484.964C625.17 490.721 607.66 499.2 599.53 503.624L599.487 503.648L599.447 503.672C591.783 508.366 577.097 518.474 567.123 528.264L566.349 529.023L567.424 529.65C590.277 542.979 613.377 548.438 633.697 550.447C642.299 551.297 650.506 551.547 658.217 551.457C657.311 554.254 656.177 556.921 654.924 559.459C624.38 559.51 585.739 554.502 549.619 530.671C560.029 518.015 580.683 503.836 589.982 498.177L589.996 498.168L590.01 498.161C599.813 492.792 624.375 480.868 646.297 474.859C678.031 490.888 690.47 507.763 694.508 522.686C697.327 533.105 696.061 542.612 694.312 550.287C693.816 552.468 693.281 554.496 692.789 556.361Z",
    fill: "#1956A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.731 541.741C620.417 536.364 620.417 527.646 629.731 522.269C639.045 516.892 654.146 516.892 663.461 522.269L664.81 523.048L631.08 542.52L629.731 541.741Z",
    fill: "#1956A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.645 510.683C631.426 513.444 631.426 517.919 626.645 520.679C621.863 523.44 614.111 523.44 609.33 520.679C604.548 517.919 604.548 513.444 609.33 510.683C614.111 507.923 621.863 507.923 626.645 510.683Z",
    fill: "#1956A8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2704_23661",
    x: 389.74,
    y: 0,
    width: 533.167,
    height: 339.208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0980392 0 0 0 0 0.337255 0 0 0 0 0.658824 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2704_23661"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2704_23661",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2704_23661",
    x: 3.21191,
    y: 84.3279,
    width: 707.64,
    height: 435.573,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0980392 0 0 0 0 0.337255 0 0 0 0 0.658824 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2704_23661"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2704_23661",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2704_23661",
    x: 417,
    y: 277,
    width: 639.585,
    height: 396.285,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0980392 0 0 0 0 0.337255 0 0 0 0 0.658824 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2704_23661"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2704_23661",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2704_23661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.6131,
    height: 18.4197,
    rx: 4,
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 486.498 497.618)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationDocuments);
export default __webpack_public_path__ + "static/media/Illustration_documents.ae8c899307ea42df285004688cddf24e.svg";
export { ForwardRef as ReactComponent };